import { type ComboboxItem } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import type { Control, FieldError } from "react-hook-form";
import { FormFieldController } from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { HelperText } from "../../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/HelperText";
import { useSupplierGenerators } from "../../../../../../DeliveryInvoices/hooks/useSupplierGenerators";
import { LoadOrError } from "../../../../../../LoadOrError/LoadOrError";
import { DELIVERY_FORM_FIELD_DATA } from "../../DeliveryForm.constants";
import type { DeliveryFormFields } from "../../DeliveryForm.types";
import { areGeneratorsValid } from "../../utils/areGeneratorsValid";
interface DeliveringGeneratorProps {
  control: Control<DeliveryFormFields>;
  error?: FieldError;
  contract: string;
  site: number | null;
  generatorsValue?: Array<string>;
  disabled?: boolean;
  resetGenerators: () => void;
}

function DeliveringGenerator({
  generatorsValue,
  control,
  error,
  contract,
  site,
  resetGenerators,
  disabled
}: DeliveringGeneratorProps) {
  const [indexKey, setIndexKey] = useState(0);
  const { isLoading, data: generators } = useSupplierGenerators(
    contract,
    site ?? undefined
  );
  const generatorChoices = useMemo(() => {
    return (
      generators?.map<ComboboxItem>((generator) => ({
        value: generator.id.toString(),
        label: generator.name
      })) ?? []
    );
  }, [generators]);

  useEffect(() => {
    const generatorsFieldState = control.getFieldState(
      DELIVERY_FORM_FIELD_DATA.generators.name
    );

    if (
      generatorsFieldState.isDirty &&
      areGeneratorsValid(generators, generatorsValue)
    ) {
      resetGenerators();
      setIndexKey((prev) => prev + 1);
    }
  }, [generators, generatorsValue, resetGenerators, control]);

  return (
    <div className="DeliveringGenerator" key={indexKey}>
      <div className="fields">
        <LoadOrError loading={isLoading}>
          {!isLoading && (
            <>
              <FormFieldController
                control={control}
                data={{
                  ...DELIVERY_FORM_FIELD_DATA.generators,
                  data: generatorChoices,
                  disabled
                }}
              />
              <HelperText error={error} />
            </>
          )}
        </LoadOrError>
      </div>
    </div>
  );
}

export { DeliveringGenerator };
